import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  EnvironmentProviders,
  makeEnvironmentProviders,
  Provider,
} from '@angular/core';
import {
  THROTTLING_CONFIG,
  ThrottlingConfig,
} from './throttling-interceptor.config';
import { ThrottlingInterceptor } from './throttling.interceptor';

/**
 * Provides the throttling interceptor with optional configuration
 */
export function provideThrottlingInterceptor(
  config?: Partial<ThrottlingConfig>,
): EnvironmentProviders {
  const providers: Provider[] = [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ThrottlingInterceptor,
      multi: true,
    },
  ];

  // Add custom configuration if provided
  if (config) {
    providers.push({
      provide: THROTTLING_CONFIG,
      useValue: {
        maxConcurrentRequests: 6,
        maxRetries: 3,
        baseRetryDelay: 1000,
        ...config,
      },
    });
  }

  return makeEnvironmentProviders(providers);
}
